import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/service/storage.service';
import { MobileMenuService } from 'src/app/service/mobile-menu.service';

@Component({
  selector: 'app-bannerusuario',
  templateUrl: './bannerusuario.component.html',
  styleUrls: ['./bannerusuario.component.css']
})
export class BannerusuarioComponent {

  seleccionado: boolean = false;
  esAdministrado: boolean = true;

  constructor(
    private storageService: StorageService,
    private route: Router,
    private storage: StorageService,
    public mobileMenu: MobileMenuService){

  }


  ngOnInit(): void {
    this.esAdministrado = this.storage.esAdministrador();

  }
  
  salir(){
    this.storageService.removeUsuarioStorage();
    this.route.navigate(['/login/ingresar']);
  }
}
